<template>
	<div class="page">
		<HeaderBar title="相关病史"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<van-cell-group title="肝硬化">
					<van-row>
						<StaticSingleSelect label="肝硬化" :selectkey.sync="form.bq419.Bq419_002" :list="existList"
							required />
						<van-checkbox-group v-model="Bq419_003s" shape="square"
							v-show="form.bq419.Bq419_002 == '有'" style="margin-bottom: 0.5rem;margin-left: 3rem;">
							<van-checkbox name="无">无</van-checkbox>
							<van-checkbox name="腹水">腹水</van-checkbox>
							<van-checkbox name="肝性脑病">肝性脑病</van-checkbox>
							<van-checkbox name="食管胃底静脉曲张破裂出血">食管胃底静脉曲张破裂出血</van-checkbox>
						</van-checkbox-group>
					</van-row>
				</van-cell-group>
				<van-cell-group title="治疗史">
					<van-row>
						<StaticSingleSelect label="治疗史" :selectkey.sync="form.bq419.Bq419_004" :list="zls" required />
					</van-row>
				</van-cell-group>
				<van-cell-group title="合并感染">
					<van-row>
						<StaticSingleSelect label="HBV感染" :selectkey.sync="form.bq419.Bq419_005" :list="existList"
							required />
						<FormNormalInput label="抗HBV治疗" v-model="form.bq419.Bq419_006"
							v-show="form.bq419.Bq419_005 == '有'" />
					</van-row>
					<van-row>
						<StaticSingleSelect label="HIV感染" :selectkey.sync="form.bq419.Bq419_007" :list="existList"
							required />
						<FormNormalInput label="抗HIV治疗" v-model="form.bq419.Bq419_008"
							v-show="form.bq419.Bq419_007 == '有'" />
					</van-row>
				</van-cell-group>

				<van-cell-group title='合并疾病  “不填写则默认无”'>
					<van-row>
						<StaticSingleSelect label="心血管系统疾病" :selectkey.sync="form.bq419.Bq419_009" :list="existList" />
						<FormNormalInput label="名称" v-model="form.bq419.Bq419_010"
							v-show="form.bq419.Bq419_009 == '有'" />
					</van-row>
					<van-row>
						<StaticSingleSelect label="呼吸系统疾病" :selectkey.sync="form.bq419.Bq419_011" :list="existList" />
						<FormNormalInput label="名称" v-model="form.bq419.Bq419_012"
							v-show="form.bq419.Bq419_011 == '有'" />
					</van-row>
					<van-row>
						<StaticSingleSelect label="消化系统疾病" :selectkey.sync="form.bq419.Bq419_013" :list="existList" />
						<FormNormalInput label="名称" v-model="form.bq419.Bq419_014"
							v-show="form.bq419.Bq419_013 == '有'" />
					</van-row>
					<van-row>
						<StaticSingleSelect label="泌尿系统疾病" :selectkey.sync="form.bq419.Bq419_015" :list="existList" />
						<FormNormalInput label="名称" v-model="form.bq419.Bq419_016"
							v-show="form.bq419.Bq419_015 == '有'" />
					</van-row>
					<van-row>
						<StaticSingleSelect label="内分泌系统疾病" :selectkey.sync="form.bq419.Bq419_017" :list="existList" />
						<FormNormalInput label="名称" v-model="form.bq419.Bq419_018"
							v-show="form.bq419.Bq419_017 == '有'" />
					</van-row>
					<van-row>
						<StaticSingleSelect label="血液系统疾病" :selectkey.sync="form.bq419.Bq419_019" :list="existList" />
						<FormNormalInput label="名称" v-model="form.bq419.Bq419_020"
							v-show="form.bq419.Bq419_019 == '有'" />
					</van-row>
					<van-row>
						<StaticSingleSelect label="风湿性疾病" :selectkey.sync="form.bq419.Bq419_021" :list="existList" />
						<FormNormalInput label="名称" v-model="form.bq419.Bq419_022"
							v-show="form.bq419.Bq419_021 == '有'" />
					</van-row>
					<van-row>
						<StaticSingleSelect label="其它" :selectkey.sync="form.bq419.Bq419_023" :list="existList" />

						<FormNormalInput label="其它名称" v-model="form.bq419.Bq419_024"
							v-show="form.bq419.Bq419_023 == '有'" />
					</van-row>
				</van-cell-group>


				<van-cell-group title="饮酒史">
					<van-row>
						<StaticSingleSelect label="饮酒史" :selectkey.sync="form.bq419.Bq419_025" :list="existList" />
						<van-row v-show="form.bq419.Bq419_025 == '有'">
							<van-col span="18">
								<FormNormalInput label="平均每日酒精摄入量" v-model="form.bq419.Bq419_026" />
							</van-col>
							<van-col span="6" class="unit">g/d</van-col>
						</van-row>
						<van-row v-show="form.bq419.Bq419_025 == '有'">
							<StaticSingleSelect label="其他" :selectkey.sync="form.bq419.Bq419_027" :list="yjList" />
						</van-row>
					</van-row>
				</van-cell-group>

				<FormNormalUpload label="查看报告" ref="normalUpload" :infoGuid='form.bq419.guid'>
				</FormNormalUpload>
				<div class="page-bottom-box" style="margin: 16px;" v-show='!savestate && bq400.Bq400_996=="0"'>
					<SaveButton :url="saveUrl" ref="btnSave" back="0" @saveSucess="saveSucess"
						:editMode="form.bq419.guid != ''" class="hide">保存
					</SaveButton>
					<van-button block type="info" @click="SaveInfo">保存</van-button>
				</div>
				<div class="page-bottom-box" style="margin: 16px;" v-show='savestate'>
					<van-button block type="info">提交中……</van-button>
				</div>
			</van-form>
		</div>
	</div>
</template>

<script>
// 引入服务组件
import componentsModel from '../../../base/components.js'
// 引入子页面的混入对象
import mixinModel from '../mixins/mixins.js'
export default {
	name: "page013",
	mixins: [mixinModel],
	data() {
		return {
			modelname: 'bq419',
			form: {
				bq419: {
					id: "0", //编号
					guid: "", //guid编号
					companyGuid: "", //单位编号
					departmentGuid: "", //部门编号
					checkStatus: "", //审核状态
					dataStatus: "", //数据状态
					addUid: "", //添加人编号
					addTime: "", //添加时间					
					Bq400_guid: '', //随访基本信息表编号
					Bq419_002: '', //
					Bq419_003: '', //
					Bq419_004: '', //
					Bq419_005: '', //
					Bq419_006: '', //
					Bq419_007: '', //
					Bq419_008: '', //
					Bq419_009: '无', //
					Bq419_010: '', //
					Bq419_011: '无', //
					Bq419_012: '', //
					Bq419_013: '无', //
					Bq419_014: '', //
					Bq419_015: '无', //
					Bq419_016: '', //
					Bq419_017: '无', //
					Bq419_018: '', //
					Bq419_019: '无', //
					Bq419_020: '', //
					Bq419_021: '无', //
					Bq419_022: '', //
					Bq419_023: '无', //
					Bq419_024: '', //
					Bq419_025: '',//
					Bq419_026: '',//
					Bq419_027: '',//
				},
				sempFiles: []
			},
			Bq419_003s: [], //
			fullscreenLoading: false,
			//保存接口
			saveUrl: this.$utils.Url.s400 + '/api/S400Bq419/Save',
			dataList: [],
			existList: [],
			zls: [{ id: '初治', name: '初治' }, { id: 'PRS经治', name: 'PRS经治' }],
			yjList: [{ id: '不确定', name: '不确定' }, { id: '已戒酒半年以上', name: '已戒酒半年以上' }, { id: '戒酒半年以内或未戒酒', name: '戒酒半年以内或未戒酒' }],
			bq400: JSON.parse(sessionStorage.getItem('bq400')),
			savestate: false,
		}
	},
	components: {
		...componentsModel
	},
	methods: {
		//加载信息
		LoadInfo: function () {
			var that = this
			var args = {
				bq400guid: this.bq400.guid
			}
			that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq419/Info', args, function (d) {
				let dataModel = d.Data
				if (dataModel != null) {
					that.$utils.CopyKeyInfo(dataModel, dataModel)
					
					that.$set(that.form, "bq419", dataModel)
					if(that.form.bq419.Bq419_003){
						that.Bq419_003s=that.form.bq419.Bq419_003.split(',')
					}
				}
			}, null, null, null);
		},

		//保存信息
		SaveInfo: function () {
			let that = this
			if(that.Bq419_003s.length>0){
				that.form.bq419.Bq419_003 = that.Bq419_003s.join(',')
			}

			that.form.sempFiles = that.$refs.normalUpload.GetFileList()
			that.$refs.btnSave.Save()
		},
	},
	mounted() {
		this.form.bq419.Bq400_guid = this.bq400.guid
		this.existList = this.$utils.setStandardList(this.$apis.s400Apis.existList)
		this.LoadInfo()
	}
}
</script>

<style scoped>
.unit {
	padding-top: 0.5rem;
	color: #999;
	font-size: 0.9em;
}
</style>
